import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IProduct } from './product.model';
import { MIHttpClientService } from 'src/app/shared/mi-http-client.service';
import { map } from 'rxjs/operators';
import { IdName } from '../../../../shared/common-interfaces';
import { sortBy, uniq, uniqBy } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(
    private miClient: MIHttpClientService,
  ) { }

  getProduct(productId): Observable<IProduct> {
    return this.miClient.get(`products/${productId}`);
  }

  createProduct(product) {
    return this.miClient.post('products/', product);
  }

  updateProduct(productId: number, product: any) {
    return this.miClient.post(`products/${productId}`, product);
  }

  deleteProduct(productId: number) {
    return this.miClient.delete(`products/${productId}`);
  }

  getProducts(): Observable<IProduct[]> {
    return this.miClient.get<IProduct[]>('products').pipe(map(products => products.map(product => {
      product.id = product.productId;
      return product;
    })));
  }

  getProductsByProjectId(projectId: number): Observable<IProduct[]> {
    return this.getProductsByProjectIds([+projectId]);
  }

  toProductTypeNames(products: IProduct[]): IdName[] {
    if (!products) {
      return [];
    }
    const items = uniqBy(products.filter(product => product.productTypeId !== null)
      .map(product => {
        return { id: product.productTypeId, name: product.productTypeName }
      }), 'id');

    return sortBy(items, item => item.name.toLowerCase());
  }

  toProductTypeNamesActivity(products: IProduct[]): IdName[] {
    if (!products) {
      return [];
    }
    const items = uniqBy(products.filter(product => product.productTypeId !== null)
      .map(product => {
        return { id: product.productTypeId, name: product.productTypeName }
      }), 'id');

    return sortBy(items, item => item.name.toLowerCase());
  }

  toProductCategoryNames(products: IProduct[]): IdName[] {
    const items = uniqBy(products.filter(product => product.productCategoryId !== null)
      .map(product => {
        return { id: product.productCategoryId, name: product.productCategoryName }
      }), 'id');

    return sortBy(items, item => item.name.toLowerCase());
  }


  getProductsByProjectIds(projectIds: number[]): Observable<IProduct[]> {
    return this.getProducts().pipe(
      map(products => {
        return products.filter(product => projectIds.includes(product.projectId))
      }),
    );
  }


}
